import axios from 'axios';

const api = axios.create({
    baseURL: 'https://api-report.garudakasir.co.id/',
    // baseURL: 'http://localhost:3010',
    timeout: 20000,
    headers: {
        'X-Custom-Header': 'foobar',
        'Content-Type': 'application/json',
        // 'Access-Control-Allow-Origin': '*',
        // 'Access-Control-Allow-Headers': '*',
        // eslint-disable-next-line prettier/prettier
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
    }
});

const interceptor = () =>
    api.interceptors.response.use(
        (res) => {
            // Add configurations here
            // if (res.status === 201) {
            // }
            return res;
        },
        (err) => {
            return err;
            //  return Promise.reject(err);
        }
    );

export { api, interceptor };
